import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable()
export class VersionService {

  constructor() { }

  public getFormattedVersion(): string {
    const versionData = environment.versionInfo;
    return versionData.version_info.major + '.' + versionData.version_info.minor + '-' + versionData.version_info.git_hash;
  }

  public getFormattedVersionShort(): string {
    const versionData = environment.versionInfo;
    return versionData.version_info.major + '.' + versionData.version_info.minor;
  }
}
